import { render, staticRenderFns } from "./site-details.vue?vue&type=template&id=7488bf5c&"
import script from "./site-details.vue?vue&type=script&lang=ts&"
export * from "./site-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports